export default "__VITE_ASSET__C54bb$bE__"